import * as z from "zod";

export const resolveShopperAgentObservability = {
  name: "resolveShopperAgentObservability" as const,
  input: z.object({ id: z.string() }),
  output: z.object({
    observedAt: z.date(),
    seed: z.object({
      kind: z.enum([
        "marketing_conversation",
        "channel_thread",
        "shopper_agent_conversation",
        "raw_id",
      ]),
      id: z.string(),
    }),
    candidates: z.array(
      z.object({
        channelThreadId: z.string(),
        rawChannelThreadId: z.string(),
        channel: z.string(),
        team: z.object({ id: z.string(), name: z.string() }),
        messageCount: z.number(),
        exactMarketingBridgeCount: z.number(),
        lastMessageAt: z.date().nullable(),
        sources: z.array(
          z.enum([
            "channel_thread",
            "shopper_agent_conversation",
            "marketing_support_message",
            "marketing_support_draft",
            "shopper_agent_metadata",
          ]),
        ),
      }),
    ),
  }),
};

export type ResolveShopperAgentObservabilityOutput = z.infer<
  typeof resolveShopperAgentObservability.output
>;
